import React from 'react';

type SuralinkLogoProps = {
  size?: number;
}

const SuralinkLogo = ({ size = 40 }: SuralinkLogoProps) => (
  <svg viewBox="0 0 18 18" width={size} height={size}>
    <path fill="#225282" d="M18,6H5.4v2.7H0v-8.7h18V6z" />
    <path fill="#404040" d="M0,12h12.6V9.3H18V18H0V12z" />
  </svg>
);

export default SuralinkLogo;
